import { confirmDialog } from "primereact/confirmdialog";
import {
  createCropCategory,
  deleteCropCategory,
  updateCropCategory,
  getAllCropCategories,
} from "../../../services/ValitanApiService";
import { enqueueSnackbar } from "notistack";

// Fetch Crop Categories
export const getCropCategories = async (page = 0, size = 10) => {
  try {
    const response = await getAllCropCategories(page, size);
    console.log(response);
    if (response.status === 200) {
      return {
        cropCategories: response.data.content,
        paginationInfo: {
          totalElements: response.data.total_elements,
          totalPages: response.data.total_pages,
          pageNumber: response.data.number,
          pageSize: response.data.size,
          sort: response.data.sort,
        },
      };
    } else {
      enqueueSnackbar(response.data.message || "Failed to fetch crop categories.", { variant: "error" });
      return { cropCategories: [], paginationInfo: {} };
    }
  } catch (error) {
    console.error("Error fetching crop categories:", error);
    enqueueSnackbar("Error fetching crop categories. Please try again.", { variant: "error" });
    return { cropCategories: [], paginationInfo: {} };
  }
};

// Delete Crop Category
export const deleteACropCategory = async (id, loadCropCategories) => {
  try {
    const response = await deleteCropCategory(id);
    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      await loadCropCategories();
    } else {
      enqueueSnackbar(response.data.message || "Failed to delete crop category.", { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Failed to delete crop category. Please try again.", { variant: "error" });
    console.error(error);
  }
};

export const confirmDeleteCropCategory = (id, loadCropCategories) => {
  confirmDialog({
    message: "Are you sure you want to delete this crop category?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteACropCategory(id, loadCropCategories),
    reject: () => {},
  });
};

// Validation on create or update
export const validateCropCategoryForm = (name, code, setErrors) => {
  let valid = true;
  const errorsCopy = { name: "", code: "" };

  if (!name.trim()) {
    errorsCopy.name = "Crop Category Name is required";
    valid = false;
  }
  if (!code.trim()) {
    errorsCopy.code = "Code is required";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};

// Create or update crop category
export const createOrUpdateCropCategory = async (
  event,
  name,
  code,
  editingCropCategoryId,
  loadCropCategories,
  toggleModal,
  setErrors
) => {
  event.preventDefault();

  if (!validateCropCategoryForm(name, code, setErrors)) {
    return;
  }

  const cropCategoryData = { name, code };

  try {
    const response = editingCropCategoryId
      ? await updateCropCategory(editingCropCategoryId, cropCategoryData)
      : await createCropCategory(cropCategoryData);

    if (response.data.status === "success") {
      enqueueSnackbar(response.data.message, { variant: "success" });
      toggleModal();
      await loadCropCategories();
    } else {
      enqueueSnackbar(response.data.message || "Failed to save crop category data.", { variant: "error" });
    }
  } catch (error) {
    console.error("Error saving crop category data:", error);
    enqueueSnackbar("Error saving crop category data. Please try again.", { variant: "error" });
  }
};
